import { lazyGlyphLoaders } from '@sunwebgroup/uds-country-flag-icons/lazyGlyphs'
import cn from 'classnames'
import * as React from 'react'
import { createSafeLazy } from './createSafeLazy'
import { createGetGlyphComponent } from './getGlyphComponent'
import styles from './IconCountryFlag.module.css'
import { IconCountryFlagProps } from './IconCountryFlag.types'

type IconCountryFlagCSSProperties = React.CSSProperties & {
  '--_icon-country-flag-size'?: string
}

const getGlyphComponent = createGetGlyphComponent({
  loaders: lazyGlyphLoaders,
  lazy: createSafeLazy(React.lazy),
})

function IconCountryFlag({ className, glyph, size = 16, ...attrs }: IconCountryFlagProps) {
  const GlyphComponent = getGlyphComponent(glyph)

  if (!GlyphComponent) {
    console.error(`Icon: No icon found for glyph "${String(glyph)}"`)
    return null
  }

  const mergedStyles: IconCountryFlagCSSProperties = { '--_icon-country-flag-size': `var(--icon-country-flag-size, ${size}px)` }

  return (
    <span className={cn(styles.iconCountryFlag, className)} style={mergedStyles}>
      <React.Suspense fallback={null}>
        <GlyphComponent {...attrs} />
      </React.Suspense>
    </span>
  )
}

export default IconCountryFlag
